"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalizeFirstLetters = exports.queryToString = void 0;
function queryToString(queryStringObj) {
    return Object.keys(queryStringObj)
        .map(function (prop) { return "".concat(prop, "=").concat(encodeURIComponent(queryStringObj[prop]).replace(/%20/g, '+').replace(/\*/g, '%2A')); })
        .join('&');
}
exports.queryToString = queryToString;
/* istanbul ignore next: todo(sagi): test */
function capitalizeFirstLetters(string) {
    if (string === void 0) { string = ''; }
    return string
        .split(' ')
        .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1).toLocaleLowerCase(); })
        .join(' ');
}
exports.capitalizeFirstLetters = capitalizeFirstLetters;
//# sourceMappingURL=utils.js.map